import { Route, Routes } from 'react-router-dom';
import { FC, Suspense } from 'react';
import { SignOutPage } from '../../authentication/SignOutPage';
import { Container } from '@mantine/core';
import classes from './ClientApplicationRoutes.module.scss';
import { SuccessPage } from './SuccessPage';
import { ClientApplicationForm } from './ClientApplicationForm';
import { UnauthorizedPage } from './UnauthorizedPage';
import { Loading } from '@medplum/react';
import { NotFoundPage } from './NotFoundPage';

export const ClientApplicationRoutes: FC = () => {
  return (
    <Container size="100vw" py="lg" className={classes.clientAppContainer}>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="client">
            <Route path="forms" element={<ClientApplicationForm />} />
            <Route path="success" element={<SuccessPage />} />
            <Route path="unauthorized" element={<UnauthorizedPage />} />
            <Route path="not-found" element={<NotFoundPage />} />
            <Route path="*" element={<SignOutPage />} />
          </Route>
          <Route path="*" element={<SignOutPage />} />
        </Routes>
      </Suspense>
    </Container>
  );
};
